import { useMutation } from '@tanstack/react-query';

import { type SourcesConnectionTestResult } from '@api/types.gen';
import { gitOpsSourcesTestById } from '@api/sdk.gen';

import { withError } from '@/react-tools/react-query';

import { SourceId } from '../types';

import { UpdateSourcePayload } from './useUpdateSourceMutation';

export type ConnectionTestResult = SourcesConnectionTestResult;

async function testSourceConnection(
  id: SourceId,
  payload: UpdateSourcePayload
): Promise<ConnectionTestResult> {
  const { data } = await gitOpsSourcesTestById({ path: { id }, body: payload });
  return data;
}

export function useTestSourceConnectionMutation() {
  return useMutation({
    mutationFn: ({
      id,
      payload = {},
    }: {
      id: SourceId;
      payload?: UpdateSourcePayload;
    }) => testSourceConnection(id, payload),
    ...withError('Connection test failed'),
  });
}
